// ConfirmModal.jsx
import React from "react";

const MissedAlert = ({ onClose }) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.topLineModel}></div>
        <h2 style={styles.modalHeader}>Incomplete Profile</h2>
        <p style={styles.modalBody}>Email, Phone, or Address Is Missing.</p>
        <div style={styles.btnBody}>
          <button
            onClick={onClose}
            style={styles.buttonConfirm}
            className="btn btn-primary"
          >
            Update Profile
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgb(0 0 0 / 64%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999999999,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "8px",
    maxWidth: "400px",
    width: "100%",
    padding: "0px",
    textAlign: "center",
    fontFamily: "Open Sans",
  },
  topLineModel: {
    backgroundColor: "var(--primary-color)",
    height: "10px",
    marginBottom: "45px",
    borderRadius: "7px 7px 0px 0px",
  },
  modalHeader: {
    color: "#000000",
    fontSize: "24px",
    marginBottom: "6px",
  },
  modalBody: {
    padding: "0px 10px",

    color: "#000000",
    margin: "0",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: 1.4,
  },
  modalBodySpan: {
    color: "var(--primary-color)",
    fontWeight: "700",
    marginLeft: "0px ",
  },
  btnBody: {
    margin: "15px auto 30px auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonConfirm: {
    backgroundColor: "var(--secondary-color)",
    color: "white",
    border: "none",
    padding: "0px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    height: "38px",
    width: "136px",
    fontSize: "14px",
    fontWeight: "500",
    margin: "0 auto",
  },
};

export default MissedAlert;
